module.exports = __webpack_public_path__ + "static/media/loc2_img16.b63445d7.jpg";